/* eslint-disable react/no-array-index-key */
import React from 'react';

const Bullets = ({ content }) => {
	if (!content) {
		return null;
	}

	return (
		<ul className="product-card__bullet-list--rebrand mt-2 text-body-xs z-10 relative">
			{content
				.filter((item) => item.replace(/\s/g, ''))
				.map((item, index) => {
					return (
						<li
							className="mt-2 flex"
							key={index}
							data-tag-name="bullet-video-clicked">
							<span className="bg-gray-70 flex-shrink-0 h-1 mt-2 rounded-full w-1" />
							<span
								className="ml-2"
								dangerouslySetInnerHTML={{ __html: item }}
							/>
						</li>
					);
				})}
		</ul>
	);
};

export default Bullets;
